import { render, staticRenderFns } from "./WarehouseImports.vue?vue&type=template&id=2ca0b3df&"
import script from "./WarehouseImports.vue?vue&type=script&lang=ts&"
export * from "./WarehouseImports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports